import { ContatoBuscaPorCampoParmDTO, ContatoParmDTO } from "@/interfaces/crm-contact";
import { ENDPOINTS } from "@/settings/api-settings";
import { from, Observable } from "rxjs";
import { map } from "rxjs/operators";
import { apiClient } from "./api";

export function listCrmContactsHierarchies(): Observable<any> {
  return from(apiClient.get(ENDPOINTS.CRM_CONTACT_HIERARCHIES)).pipe(
    map((r: any) => {
      return !!r && r.data ? r.data : {};
    }),
  );
}

export function listCrmContactsPositions(): Observable<any> {
  return from(apiClient.get(ENDPOINTS.CRM_CONTACT_POSITIONS)).pipe(
    map((r: any) => {
      return !!r && r.data ? r.data : {};
    }),
  );
}

export function saveCrmContacts(parm: ContatoParmDTO): Observable<any> {
  return from(apiClient.post(ENDPOINTS.CRM_CONTACT, parm)).pipe(
    map((r: any) => {
      return !!r && r.data ? r.data : {};
    }),
  );
}

export function updateCrmContacts(parm: ContatoParmDTO): Observable<any> {
  return from(apiClient.put(ENDPOINTS.CRM_CONTACT, parm)).pipe(
    map((r: any) => {
      return !!r && r.data ? r.data : {};
    }),
  );
}

export function listCrmContactsByFilters(filters): Observable<any> {
  return from(apiClient.get(ENDPOINTS.CRM_CONTACT, filters)).pipe(
    map((r: any) => {
      return !!r && r.data ? r.data : {};
    }),
  );
}

export function getCrmContactDetails(id: number): Observable<any> {
  return from(apiClient.get(`${ENDPOINTS.CRM_CONTACT}/${id}`,)).pipe(
    map((r: any) => {
      return !!r && r.data ? r.data : {};
    }),
  );
}

export function findCrmContactDetailsByField(parms: ContatoBuscaPorCampoParmDTO): Observable<any> {
  return from(apiClient.get(`${ENDPOINTS.CRM_CONTACT_BY_FIELD}`, parms)).pipe(
    map((r: any) => {
      return !!r && r.data ? r.data : {};
    }),
  );
}

export function updateActivationCrmContact(id: number, status: boolean): Observable<any> {
  return from(apiClient.put(ENDPOINTS.CRM_CONTACT_ACTIVATION, { id, ativo: status })).pipe(
    map((r: any) => {
      return !!r && r.data ? r.data : {};
    }),
  );
}

export function listCrmContactsCombo(idsNotIn: number[], idInstitution: number) {
  return from(apiClient.get(ENDPOINTS.CRM_CONTACT_COMBO, { idsNotIn: idsNotIn, idInstituicao: idInstitution })).pipe(
    map((r: any) => {
      return !!r && r.data ? r.data : {};
    }),
  );
}
